const AI_REDUX_CONSTANT = {
    // Strategy constants
    SET_STRATEGIES: 'SET_STRATEGIES',
    SET_CURRENT_STRATEGY: 'SET_CURRENT_STRATEGY',
    SET_GENERATING_PERSONAS: 'SET_GENERATING_PERSONAS',
    SET_PERSONAS_ERROR: 'SET_PERSONAS_ERROR',
    UPDATE_STRATEGY: 'UPDATE_STRATEGY',
    DELETE_STRATEGY: 'DELETE_STRATEGY',

    // Message constants
    SET_GENERATED_MESSAGES: 'SET_GENERATED_MESSAGES',
    SET_GENERATING_MESSAGE: 'SET_GENERATING_MESSAGE',
    SET_MESSAGE_ERROR: 'SET_MESSAGE_ERROR',
    SET_MESSAGE_HISTORY: 'SET_MESSAGE_HISTORY',
    SET_MESSAGE_STATS: 'SET_MESSAGE_STATS',
};

export default AI_REDUX_CONSTANT;
